import React from 'react'

import { Box } from 'ui/components/Box'
import { Button } from 'ui/components/Button'

import { useSelectedRecordsActionsState } from './hooks/useSelectedRecordsActionsState'

type SelectedRecordsActionsProps = {}

export const SelectedRecordsActions: React.FC<SelectedRecordsActionsProps> = () => {
    const { buttonLabel, deleteRecordsSelected } = useSelectedRecordsActionsState()

    return (
        <Box width="full" flex center justifyContent="flex-end">
            <Button
                variant="critical"
                size="xs"
                startIcon={{ name: 'Trash' }}
                onClick={deleteRecordsSelected}
            >
                {buttonLabel}
            </Button>
        </Box>
    )
}
